import { useEffect, useState } from "react";
import background from "../../assets/images/background.png";
import { HOME_ROUTE, SETUP_ACCOUNT_STEP_TWO_ROUTE, SIGNUP_ROUTE } from "../../routes";
import { isAuthenticated } from "../../services/firebase";
import validateEmail from "../../utility/validator/email-validation";
import validatePhoneNumber from "../../utility/validator/phone-no-validation";
import * as bootstrap from "bootstrap";
import { logout } from "../../services/firebase";
import axios from "axios";
import dataProvider from "../../services/dataProvider";
import authServices from "../../services/authServices";
import formatDate from "../../utility/formatDate";
import DatePicker from "react-datepicker";
import normalizeDate from "../../utility/normalizeDate";

const SetupAccountStep1 = ({ history, ...props }) => {
    // states for field variables

    const baseState = {
        fullName: "",
        role: "",
        issue: "",
        mobileNumber: "",
        secondaryEmail: "",
        registrationType: "",
        registrationNumber: "",
        plan: "",
        expiry: "",
        secondaryMobileNumber: "",
    };

    const [formData, setFormData] = useState(baseState);

    // error states
    const [secondaryEmailError, setSecondaryEmailError] = useState(false);
    const [mobileNumberError, setMobileNumberError] = useState(false);
    const [secondaryMobileNumberError, setSecondaryMobileNumberError] = useState(false);

    useEffect(async () => {
        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
        tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl);
        });

        setFormData({
            ...formData,
            plan: props?.location?.state?.subscriberInfo?.plan || "",
        });

        if (!isAuthenticated()) {
            history.replace(SIGNUP_ROUTE);
        }

        // check if user has paid or not

        let res = await axios.get(dataProvider.baseUrl + "checkIfStep2DetailsExists", {
            headers: {
                token: authServices.getToken(),
            },
        });

        if (res.data.status === "success") {
            //console.log(res.data.userData);
            let complyData = res.data?.userData?.complyData;
            if (complyData && Object.keys(complyData).length > 0) {
                setFormData(complyData);
            }
        }
    }, []);

    function handleCancel() {
        logout();
        history.replace(HOME_ROUTE);
    }

    function handleSubmit(e) {
        e.preventDefault();

        let formHasError = false;

        if (formData.secondaryEmail !== "" && !validateEmail(formData.secondaryEmail)) {
            setSecondaryEmailError(true);
            formHasError = true;
        }

        if (!validatePhoneNumber(formData.mobileNumber)) {
            setMobileNumberError(true);
            formHasError = true;
        }

        if (!validatePhoneNumber(formData.secondaryMobileNumber)) {
            setSecondaryMobileNumberError(true);
            formHasError = true;
        }

        if (formHasError) {
            return false;
        }

        const subscriberInfo = {
            ...formData,
            stepOneCompleted: true,
        };

        //console.log(subscriberInfo);
        history.push(SETUP_ACCOUNT_STEP_TWO_ROUTE, { subscriberInfo });

        return false;
    }

    return (
        <div
            id="chose-plan"
            style={{
                backgroundImage: `url(${background})`,
                minHeight: "100vh",
            }}
        >
            <div className="container pb-5">
                <div className="btn mt-3">
                    <span className="material-icons text-light h3" onClick={handleCancel}>
                        close
                    </span>
                </div>
                <h1 className="text-center text-light mt-5">Setup account</h1>
                <div className="d-flex flex-column align-items-center">
                    <form className="w-100" style={{ maxWidth: "64rem" }} onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-lg">
                                <input
                                    style={{ height: "3rem" }}
                                    type="text"
                                    placeholder="Full Name *"
                                    value={formData.fullName}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            fullName: e.target.value,
                                        })
                                    }
                                    className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                                    required
                                />
                                <input
                                    style={{ height: "3rem" }}
                                    type="text"
                                    placeholder="Role *"
                                    value={formData.role}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            role: e.target.value,
                                        })
                                    }
                                    className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom my-4 h5"
                                    required
                                />
                                <div className="my-4 position-relative">
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom h5 transparent-date-field"
                                        placeholderText="Issue date of License/Certificate *"
                                        selected={
                                            isNaN(
                                                new Date(parseInt(formData.issueInMilliSeconds)).getTime()
                                            ) ? null : new Date(parseInt(formData.issueInMilliSeconds))
                                        }
                                        onChange={(date) =>
                                            setFormData((fs) => ({
                                                ...fs,
                                                issue: normalizeDate(date?.getTime()||""),
                                                issueInMilliSeconds:date?.getTime()||null,
                                            }))
                                        }
                                    />
                                    <div className="datepicker-icon"></div>
                                </div>
                                <div className="my-4">
                                    <input
                                        style={{ height: "3rem" }}
                                        type="text"
                                        placeholder="Mobile Number *"
                                        value={formData.mobileNumber}
                                        onChange={(e) => {
                                            setFormData({
                                                ...formData,
                                                mobileNumber: e.target.value,
                                            });
                                        }}
                                        onBlur={(e)=>{
                                            if (!validatePhoneNumber(e.target.value)) {
                                                setMobileNumberError(true);
                                            } else {
                                                setMobileNumberError(false);
                                            }
                                        }}
                                        className={
                                            "form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom h5 " +
                                            (mobileNumberError ? " is-invalid" : "")
                                        }
                                        required
                                    />
                                    {mobileNumberError && (
                                        <div className="position-absolute text-danger">Invalid Mobile Number</div>
                                    )}
                                </div>
                                <div className="my-4">
                                    <input
                                        style={{ height: "3rem" }}
                                        type="text"
                                        placeholder="Secondary Email Address"
                                        value={formData.secondaryEmail}
                                        onChange={(e) => {
                                            setFormData({
                                                ...formData,
                                                secondaryEmail: e.target.value,
                                            });
                                        }}
                                        onBlur={(e)=>{
                                            if (!validateEmail(e.target.value)) {
                                                setSecondaryEmailError(true);
                                            } else {
                                                setSecondaryEmailError(false);
                                            }
                                        }}
                                        className={
                                            "form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom h5 " +
                                            (secondaryEmailError && formData.secondaryEmail ? "is-invalid" : "")
                                        }
                                    />
                                    {secondaryEmailError && formData.secondaryEmail && (
                                        <div className="position-absolute text-danger">Invalid Email Address</div>
                                    )}
                                </div>
                            </div>
                            <div className="col-lg">
                                <div className="d-lg-flex d-md-block">
                                    <div className="my-4" style={{ flex: "3" }}>
                                        <select
                                            style={{ height: "3rem" }}
                                            value={formData.registrationType}
                                            onChange={(e) =>
                                                setFormData({
                                                    ...formData,
                                                    registrationType: e.target.value,
                                                })
                                            }
                                            className="m-0 form-select no-border rounded-0 text-light bg-transparent border-0 border-bottom h5"
                                            aria-label="Type"
                                            required
                                        >
                                            <option className="text-2" value="" disabled>
                                                Type
                                            </option>
                                            <option className="text-2" value="class1">
                                                Class 1
                                            </option>
                                            <option className="text-2" value="class2">
                                                Class 2
                                            </option>
                                            <option className="text-2" value="assistantAgent">
                                                Assistant Agent
                                            </option>
                                        </select>
                                    </div>
                                    <div className="me-4"></div>
                                    <div className="my-4" style={{ flex: "7" }}>
                                        <div className="position-relative">
                                            <input
                                                style={{ height: "3rem" }}
                                                type="text"
                                                placeholder="License Number *"
                                                value={formData.registrationNumber}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        registrationNumber: e.target.value,
                                                    })
                                                }
                                                className="m-0 form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom h5"
                                                required
                                            />
                                            <a
                                                href="https://www.onegov.nsw.gov.au/publicregister/#/publicregister/search/Property"
                                                className="position-absolute top-50 translate-middle"
                                                style={{ right: "0" }}
                                                data-bs-toggle="tooltip"
                                                title="Find Your License Number"
                                                data-bs-html="true"
                                                target="_blank"
                                            >
                                                <span className="material-icons text-light">search</span>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <select
                                    style={{ height: "3rem" }}
                                    value={formData.plan}
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            plan: e.target.value,
                                        })
                                    }
                                    className="mb-4 form-select no-border rounded-0 text-light bg-transparent border-0 border-bottom h5"
                                    aria-label="Plan"
                                    required
                                >
                                    <option className="text-2" value="" disabled>
                                        Plan
                                    </option>
                                    <option className="text-2" value="STARTUP_PLAN_ID">
                                        Starter
                                    </option>
                                    <option className="text-2" value="BUSINESS_BUILDER_ID">
                                        Business Builder
                                    </option>
                                    <option className="text-2" value="CORPORATE_PRICE_ID">
                                        Corporate
                                    </option>
                                </select>
                                <div className="my-4 position-relative transparent-date-field-container">
                                    <DatePicker
                                        dateFormat="dd/MM/yyyy"
                                        className="form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom h5 transparent-date-field"
                                        selected={
                                            isNaN(
                                                new Date(parseInt(formData.expiryInMilliSeconds)).getTime()
                                            ) ? null : new Date(parseInt(formData.expiryInMilliSeconds))
                                        }
                                        placeholderText="Expiry date of License/Certificate *"
                                        onChange={(date) =>
                                            setFormData((fs) => ({
                                                ...fs,
                                                expiry: normalizeDate(date?.getTime()||""),
                                                expiryInMilliSeconds: date?.getTime()||null,
                                            }))
                                        }
                                    />
                                    <div className="datepicker-icon"></div>
                                </div>
                                <div className="my-4">
                                    <input
                                        style={{ height: "3rem" }}
                                        type="text"
                                        placeholder="Secondary Mobile Number *"
                                        value={formData.secondaryMobileNumber}
                                        onChange={(e) => {
                                            setFormData({
                                                ...formData,
                                                secondaryMobileNumber: e.target.value,
                                            });
                                        }}
                                        onBlur={(e)=>{
                                            if (!validatePhoneNumber(e.target.value)) {
                                                setSecondaryMobileNumberError(true);
                                            } else {
                                                setSecondaryMobileNumberError(false);
                                            }
                                        }}
                                        className={
                                            "form-control no-border rounded-0 text-light bg-transparent border-0 border-bottom h5 " +
                                            (secondaryMobileNumberError ? "is-invalid" : "")
                                        }
                                        required
                                    />
                                    {secondaryMobileNumberError && (
                                        <div className="position-absolute text-danger">Invalid Mobile Number</div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="d-flex">
                            <div className="flex-fill"></div>

                            <button
                                style={{ height: "3rem" }}
                                className="btn btn-outline-light rounded-pill px-5 text-btn"
                            >
                                Next
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SetupAccountStep1;
